export const dateTimeRenderer = (_instance, td, _row, _col, _prop, value) => {
  if (value == null || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  let date;

  date = new Date(value);

  const output = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  td.innerHTML = `<div class="truncated">${output}</div>`;

  return td;
};
